import React from 'react'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'
import * as yup from 'yup'
import { Field, Formik } from 'formik'

import TextField from '../TextField'
import Button from '../Button'
import ManufacturerSelect from '../Manufacturers/Select'
import Form, { Group, Heading } from '../Form'

const CREATE_MODEL = gql`
  mutation createModel(
  $name: String!
  $manufacturerName: String!
  $manufacturer: ID!
  ) {
    createModel(
      name: $name
      manufacturerName: $manufacturerName
      manufacturer: $manufacturer
    ) {
      id
    }
  }
`

var validationSchema = yup.object().shape({
  name: yup.string().required('Our name is required'),
  manufacturerName: yup.string().required('Manufacturer name is required'),
  manufacturer: yup.string().required('Manufacturer is required')
})

const INITIAL_VALUES = {
  name: '',
  manufacturerName: '',
  manufacturer: ''
}

const onSubmit = (values, {setSubmitting}, createModel) => {
  createModel({variables: values})
  setSubmitting(false)
}

const Create = ({onCompleted, onError}) =>
  <Mutation
    mutation={CREATE_MODEL}
    onCompleted={onCompleted}
    onError={onError}>
    {(createModel, {loading}) =>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => onSubmit(values, actions, createModel)}>
        {({isSubmitting}) =>
          <Form>
            <Heading>General</Heading>
            <Group>
              <Field component={TextField} name='name' label='What do we call it?' required autoComplete='off' />
              <Field component={TextField} name='manufacturerName' label='What does the manufacturer call it?' required autoComplete='off' />
            </Group>
            <Field component={ManufacturerSelect} name='manufacturer' placeholder='Select a manufacturer...' />
            <Button type='submit' fluid disabled={loading || isSubmitting}>Create New Model</Button>
          </Form>
        }
      </Formik>
    }
  </Mutation>

export default Create


// WEBPACK FOOTER //
// ./src/components/Models/Create.js